import type { ByecodeSize } from '@byecode/ui'
import { IconFont, Input, pointer } from '@byecode/ui'
import styled from 'styled-components'

const SIZE_MAP = {
    xs: 24,
    sm: 28,
    md: 32,
    lg: 36,
    xl: 40
}

export const ParamsInput = styled(Input)<{ width?: string }>`
    width: ${({ width }) => width || 'auto'};

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        appearance: none !important;
        margin: 0;
    }
`

export const Icon = styled(IconFont)<{ size?: number; isAction?: boolean; color?: string }>`
    font-size: ${({ size }) => size ?? '16'}px;
    background-color: transparent;
    color: ${({ color }) => color ?? 'var(--color-gray-400)'};
    ${pointer}

    &:hover {
        color: ${({ isAction }) => isAction && 'var(--color-black)'};
    }
`

export const IconWrapper = styled.div`
    display: flex;
    gap: 2px;
    align-items: center;
`
export const ItemContainer = styled.div<{ size?: ByecodeSize }>`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    background-color: var(--color-gray-100);
    padding: 0 8px;
    height: ${({ size }) => `${SIZE_MAP[size ?? 'md']}px`};
    border-radius: 6px;
    overflow: hidden;
    cursor: pointer;

    :hover {
        background-color: var(--color-gray-200);
    }
`

export const ItemWrapper = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    overflow: hidden;
`
